// src/App.js
import React from 'react';
import Hero from './components/Hero';
import Header from './components/Header';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import ClientResults from './components/ClientResults';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';


function App() {
  return (
    <div className="bg-background min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Process />
      <ClientResults />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;
